import * as _ from 'underscore'

import { ConvertHelper, TypeHelper } from "../../helpers"
import { Enums } from "../common"
import { OpFile } from '../core'
import { OpTaskData } from "../core/op-task-data"
import { Utils } from "../util/utils"

export class OpTaskProtocolVerification {
    //#region Members

    public protocolType: Enums.TaskVisitStepType
    public timestamp: Date
    public dataFromServer: OpTaskData[]
    public descriptionFromServer: string
    public dataFromApplication: OpTaskData[]
    public descriptionFromApplication: string
    public statusTaskData: OpTaskData
    public cancelationTaskData: OpTaskData
    public statusDescription: string
    public relatedAttachment: OpFile[]
    public get serverIndexNbr(): number {
        if (_.size(this.dataFromServer) > 0) {
            return _.first(this.dataFromServer).indexNbr
        }

        return null
    }
    public get applicationIndexNbr(): number {
        if (this.statusTaskData != null) {
            return this.statusTaskData.indexNbr
        }
        else if (this.cancelationTaskData != null) {
            return this.cancelationTaskData.indexNbr
        }
        else if (_.size(this.dataFromApplication) > 0) {
            return _.first(this.dataFromApplication).indexNbr
        }

        return null
    }

    //#endregion

    // Ctor

    public constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    // Ctor End

    // IJsonSerializable Implementation

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj != null) {

            if (compressed || Utils.isJSONCompressed(opObj)) {
                this.protocolType = opObj.P
                this.timestamp = opObj.T != null ? ConvertHelper.stringToDate(opObj.T) : null
                this.dataFromServer = opObj.S != null ? opObj.S.map((dfs: any) => new OpTaskData(dfs)) : null
                this.descriptionFromServer = opObj.F
                this.dataFromApplication = opObj.A != null ? opObj.A.map((dfa: any) => new OpTaskData(dfa)) : null
                this.descriptionFromApplication = opObj.K
                this.statusTaskData = opObj.D != null ? new OpTaskData(opObj.D) : null
                this.cancelationTaskData = opObj.C != null ? new OpTaskData(opObj.C) : null
                this.statusDescription = opObj.U
                this.relatedAttachment = opObj.R != null? opObj.R.map((ra: any) => new OpFile(ra)) : null
            }
            else {
                this.protocolType = opObj.ProtocolType
                this.timestamp = opObj.Timestamp != null ? ConvertHelper.stringToDate(opObj.Timestamp) : null
                this.dataFromServer = opObj.DataFromServer != null ? opObj.DataFromServer.map((dfs: any) => new OpTaskData(dfs)) : null
                this.descriptionFromServer = opObj.DescriptionFromServer
                this.dataFromApplication = opObj.DataFromApplication != null ? opObj.DataFromApplication.map((dfa: any) => new OpTaskData(dfa)) : null
                this.descriptionFromApplication = opObj.DescriptionFromApplication
                this.statusTaskData = opObj.StatusTaskData != null ? new OpTaskData(opObj.StatusTaskData) : null
                this.cancelationTaskData = opObj.CancelationTaskData != null ? new OpTaskData(opObj.CancelationTaskData) : null
                this.statusDescription = opObj.StatusDescription
                this.relatedAttachment = opObj.RelatedAttachment != null ? opObj.RelatedAttachment.map((ra: any) => new OpFile(ra)) : null
            }
        }
    }

    public toJSON(compressed: boolean = false): any {
        if (compressed) {
            const result: any = {
                P: this.protocolType,
                T: this.timestamp != null ? ConvertHelper.dateToString(this.timestamp) : null,
                S: this.dataFromServer != null ? this.dataFromServer.map((dfs: OpTaskData) => dfs.toJSON()) : null,
                F: this.descriptionFromServer,
                A: this.dataFromApplication != null ? this.dataFromApplication.map((dfa: OpTaskData) => dfa.toJSON()) : null,
                K: this.descriptionFromApplication,
                D: this.statusTaskData,
                C: this.cancelationTaskData,
                U: this.statusDescription,
                R: this.relatedAttachment != null ? this.relatedAttachment.map((ra: OpFile) => ra.toJSON()) : null
            }

            Utils.setJSONCompressedFlag(result)
            TypeHelper.deleteNulls(result)

            return result
        }

        return {
            ProtocolType: this.protocolType,
            Timestamp: this.timestamp != null ? ConvertHelper.dateToString(this.timestamp) : null,
            DataFromServer: this.dataFromServer != null ? this.dataFromServer.map((dfs: OpTaskData) => dfs.toJSON()) : null,
            DescriptionFromServer: this.descriptionFromServer,
            DataFromApplication: this.dataFromApplication != null ? this.dataFromApplication.map((dfa: OpTaskData) => dfa.toJSON()) : null,
            DescriptionFromApplication: this.descriptionFromApplication,
            StatusTaskData: this.statusTaskData,
            CancelationTaskData: this.cancelationTaskData,
            StatusDescription: this.statusDescription,
            RelatedAttachment: this.relatedAttachment != null ? this.relatedAttachment.map((ra: OpFile) => ra.toJSON()) : null
        }
    }

    // IJsonSerializable Implementation End

    public toString(): string {
        return (this.descriptionFromApplication != null && this.descriptionFromApplication != TypeHelper.emptyString) ? this.descriptionFromApplication : this.descriptionFromServer;
    }

}